// extracted by mini-css-extract-plugin
module.exports = {"White":"#FFFFFF","BreakpointFromLarge":"(min-width: 960px)","textWrapper":"Openings_textWrapper__BYnaH","wrapper":"Openings_wrapper__KwSXz"};